module.exports = __webpack_public_path__ + "static/img/Game.59bcd11.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cutehub/imgs/browse/Game.jpg
// module id = 2317
// module chunks = 0